import clsx from 'clsx'
import { useIntl } from 'react-intl'

import { type MeetingDomain } from '../../types/domain/meeting-domain'
import { Meeting } from './Meeting'

interface MeetingsTableDesktopProps {
  meetings: MeetingDomain[]
  messageSpace: boolean
}

export const MeetingListingDesktop = ({
  meetings,
  messageSpace,
}: MeetingsTableDesktopProps) => {
  const pendents = meetings?.filter(({ status }) => (status === 'start' || status === 'profile' || status === 'availability' || status === 'scheduled' || status === 'onhold'))
  const concluded = meetings?.filter(
    ({ status }) => status === 'accomplished' || status === 'canceled' || status === 'refused' || status === 'finished'
  ).sort((a, b) => {
    const dateA = new Date(a.startAt)
    const dateB = new Date(b.startAt)
    return dateB.getTime() - dateA.getTime()
  })

  const { formatMessage } = useIntl()

  return (
    <div className="flex max-w-3xl gap-4 mx-auto h-[calc(100vh_-_270px)]">
      <ul className="flex-1">
        <strong className="flex-1 block w-full p-4 py-3 text-base font-bold text-center text-white rounded-lg bg-primary-light">
          {formatMessage({ id: 'NEXT_MEETINGS' })}
        </strong>

        <div
          className={clsx('mt-4 pr-1 overflow-y-auto scrollbar', {
            'max-h-[calc(100vh_-_331px)]': messageSpace,
            'max-h-[calc(100vh_-_256px)]': !messageSpace,
          })}
        >
          {pendents.length > 0 ? (
            <>
              {pendents.map((meeting) => (
                <li key={meeting.id} className="mb-3">
                  <Meeting meeting={meeting} />
                </li>
              ))}
            </>
          ) : (
            <p className="mt-3 text-center text-grey-700">
              {formatMessage({ id: 'NO_MEETING_SCHEDULED' })}
            </p>
          )}
        </div>
      </ul>

      <ul className="flex-1">
        <strong className="flex-1 block w-full p-4 py-3 text-base font-bold text-center text-white rounded-lg bg-primary-light">
          {formatMessage({ id: 'COMPLETED_METTINGS' })}
        </strong>

        <div
          className={clsx('mt-4 pr-1 overflow-y-auto scrollbar', {
            'max-h-[calc(100vh_-_331px)]': messageSpace,
            'max-h-[calc(100vh_-_256px)]': !messageSpace,
          })}
        >
          {concluded.length > 0 ? (
            <>
              {concluded.map((meeting) => (
                <li key={meeting.id} className="mb-3">
                  <Meeting meeting={meeting} />
                </li>
              ))}
            </>
          ) : (
            <p className="mt-3 text-center text-grey-700">
              {formatMessage({ id: 'NO_MEETING_COMPLETED' })}
            </p>
          )}
        </div>
      </ul>
    </div>
  )
}
